{
  "hub": {
    "title": "コレクション一覧 | カードオークションカテゴリー — BidNova",
    "description": "ゲーム、グレード、キャラクター、言語、フォーマット別に厳選されたBidNova Auctionsのカードオークションコレクションをご覧ください。",
    "h1": "コレクション一覧",
    "intro": "ゲーム、グレード、キャラクター、言語、フォーマットごとに厳選されたライブカードオークションのコレクションをご紹介します。",
    "kinds": {
      "game": "ゲーム別",
      "grade": "グレード別",
      "character": "キャラクター別",
      "language": "言語別",
      "format": "フォーマット別"
    }
  },
  "common": {
    "breadcrumbHome": "ホーム",
    "breadcrumbAuctions": "オークション",
    "breadcrumbCollections": "コレクション一覧",
    "relatedLabel": "関連コレクション",
    "faqLabel": "よくある質問",
    "browseAllCta": "該当する出品をすべて見る",
    "emptyState": "現在ライブ中の{label}オークションはありません。新しい出品は随時追加されますので、すべてのオークションをご覧いただくか、後ほど再度ご確認ください。",
    "whyBuyTitle": "BidNovaで購入する理由",
    "whyBuyBody": "BidNovaは英国登録のマーケットプレイスです。すべての出品は公開評価を持つ認証済み出品者によるもので、英ポンド建て、Stripeで決済されます。資金は商品到着の確認までお預かりします。",
    "whyBuyPoint1": "Stripeによる安全な決済とバイヤー保護。",
    "whyBuyPoint2": "公開評価と紛争解決制度を備えた認証済み英国出品者。",
    "whyBuyPoint3": "英ポンド建て — 為替手数料の心配なし。",
    "sellingTitle": "{label}を出品しませんか？",
    "sellingBody": "承認済みの出品者は、シングルカードや未開封商品と共に1つのダッシュボードから出品できます。写真、鑑定情報、開始価格を追加するだけで数分で出品完了です。",
    "sellCta": "出品を始める"
  },
  "pokemonAuctions": {
    "title": "ポケモンカードオークション — 英国ライブ入札 | BidNova",
    "description": "鑑定済み・生カード問わずポケモンカードの英国ライブオークション。Stripeによる安全な決済、認証済み出品者、英ポンド表示。",
    "intro": "ポケモンカードの英国ライブオークションをご覧ください。ノーマルカードからPSA・BGS鑑定の人気カードまで揃います。すべての出品は認証済み出品者によるもので、英ポンド建て、Stripeの安全な決済で保護されています。"
  },
  "onePieceAuctions": {
    "title": "ワンピースカードゲームオークション | BidNova",
    "description": "ワンピースカードゲームのシングルカードや未開封商品の英国ライブオークション。英語版・日本語版、生カード・鑑定カードともに対応。",
    "intro": "ワンピースカードゲームのライブオークションをご覧ください。英語版・日本語版のシングルカード、アートレアから未開封BOXまで、生カードからPSA・BGS・CGC鑑定カードまで幅広く揃います。"
  },
  "yugiohAuctions": {
    "title": "遊戯王カードオークション | BidNova",
    "description": "英国の遊戯王カードライブオークション — ビンテージから現行カードまで、鑑定・生カード、英語版・日本語版に対応。",
    "intro": "初期の1stエディションの名品から現行の主力カードまで揃う遊戯王ライブオークション。認証済み英国出品者による生カードと専門鑑定カードをご覧ください。"
  },
  "psa10Cards": {
    "title": "PSA 10 ジェムミントカードオークション | BidNova",
    "description": "ポケモン、ワンピース、スポーツカードなど幅広いジャンルのPSA 10ジェムミントカードのライブオークション。",
    "intro": "PSA 10ジェムミントはセンタリング・表面・角の状態が最高水準であることを示します。あらゆる主要トレーディングカードゲームを網羅するライブオークションをご覧ください。各出品にはPSA証明書番号が記載され、真贋確認が可能です。"
  },
  "bgsBlackLabel": {
    "title": "BGS ブラックラベル10オークション | BidNova",
    "description": "四項目すべてが満点の、極めて希少なBGSブラックラベル10カードのライブオークション。",
    "intro": "BGSブラックラベルはBeckett社が付与する最も希少な認定で、センタリング・角・エッジ・表面のすべてが満点10です。認証済み英国出品者によるブラックラベルのライブオークションをご覧ください。"
  },
  "cgcPristine": {
    "q1": "CGCプリスティン10とは何ですか？",
    "a1": "プリスティン10はCGCの最高グレードで、センタリング・表面・角・エッジがほぼ完璧なカードにのみ付与されます。",
    "q2": "CGCプリスティン10はPSA 10と同じですか？",
    "a2": "評価基準が異なりますが、CGCプリスティン10は一般的にPSA 10と同等かそれ以上に厳格とされています。",
    "q3": "CGC鑑定が多いジャンルは？",
    "a3": "CGCはトレーディングカード、漫画、コミック、未開封商品など、ポケモン・ワンピース・スポーツカードを含む幅広いジャンルを鑑定しています。",
    "q4": "CGCの証明書を確認できますか？",
    "a4": "はい。出品にはCGC証明書番号が記載されており、CGC公式サイトで確認できます。"
  },
  "charizard": {
    "q1": "なぜリザードンはコレクターに人気なのですか？",
    "a1": "リザードンは初代Base Setの頃からファンに愛されるポケモンで、長年にわたり強いコレクター需要を集めています。",
    "q2": "鑑定済みのリザードンカードはありますか？",
    "a2": "はい。PSA・BGS・CGC鑑定のリザードンカードが多くのセットで生カードと共に出品されています。",
    "q3": "日本語版のリザードンカードは見つかりますか？",
    "a3": "はい。カード言語で絞り込むことで日本語版リザードンカードを見つけられます。",
    "q4": "ビンテージのBase Setリザードンはありますか？",
    "a4": "ビンテージ・現行どちらのリザードンも出品されています。出品詳細でセットやエディションをご確認ください。"
  },
  "pikachu": {
    "q1": "ピカチュウカードの魅力は何ですか？",
    "a1": "ポケモンのマスコットであるピカチュウは、数多くのプロモ、イラストレーター版、特別版に登場し、コレクターに高く評価されています。",
    "q2": "イラストレーター風のピカチュウプロモは出品されますか？",
    "a2": "希少なピカチュウプロモは時折出品されます。現在の出品をご確認の上、検索通知を設定してください。",
    "q3": "鑑定済みのピカチュウカードはありますか？",
    "a3": "はい。PSA・BGS・CGC鑑定のピカチュウカードが生カードと共に出品されています。",
    "q4": "日本語版のピカチュウカードはありますか？",
    "a4": "はい。カード言語で絞り込むことで日本語版ピカチュウカードを見つけられます。"
  },
  "umbreon": {
    "q1": "なぜブラッキーのカードは人気があるのですか？",
    "a1": "ブラッキーのイーブイ進化系イラスト、特にゴールドスターやVMAXアートレア版はコレクターに非常に高く評価されています。",
    "q2": "鑑定済みのブラッキーカードはありますか？",
    "a2": "はい。PSA・BGS・CGC鑑定のブラッキーカードが生カードと共に出品されています。",
    "q3": "ブラッキーVMAXアートレアは見つかりますか？",
    "a3": "アートレアやシークレットレアのブラッキーは在庫がある際に出品されます。現在のライブ出品をご確認ください。",
    "q4": "日本語版のブラッキーカードはありますか？",
    "a4": "はい。カード言語で絞り込むことで日本語版ブラッキーカードを見つけられます。"
  },
  "luffy": {
    "q1": "ルフィのカードはどのセットにありますか？",
    "a1": "ルフィは多くのワンピースカードゲームのセットでリーダーカードやキャラクターカードとして登場し、人気の高いアートレア版もあります。",
    "q2": "鑑定済みのルフィカードはありますか？",
    "a2": "はい。PSA・BGS・CGC鑑定のルフィカードが生カードと共に出品されています。",
    "q3": "日本語版のルフィカードは見つかりますか？",
    "a3": "はい。カード言語で絞り込むことで日本語版ルフィカードを見つけられます。",
    "q4": "漫画絵柄のルフィカードはありますか？",
    "a4": "ルフィを描いた漫画絵柄のパラレルカードが時折出品されます。漫画絵柄コレクションもぜひご覧ください。"
  },
  "mangaCards": {
    "title": "漫画絵柄カードオークション | BidNova",
    "description": "ワンピースカードゲームを中心とした漫画絵柄パラレルカードの英国ライブオークション。",
    "intro": "漫画カードは白黒の漫画絵柄を使用した低確率のパラレルで、主にワンピースカードゲームで見られます。認証済み英国出品者による漫画絵柄カードのライブオークションをご覧ください。"
  },
  "japaneseCards": {
    "title": "日本語版カードオークション | BidNova",
    "description": "日本語版のポケモン、ワンピース、遊戯王カードの英国ライブオークション。生カード・鑑定カード対応。",
    "intro": "日本語版カードは上質な用紙、早期発売、独自のイラストなどから高く評価されています。あらゆる主要トレーディングカードゲームの日本語版カードのライブオークションをご覧ください。"
  },
  "englishCards": {
    "title": "英語版カードオークション | BidNova",
    "description": "ポケモン、ワンピース、遊戯王など幅広いジャンルの英語版カードの英国ライブオークション。",
    "intro": "英語版カードはBidNovaのライブ出品の大部分を占め、シングルカード、未開封商品、主要な鑑定会社のカードを網羅しています。認証済み英国出品者による豊富な品揃えをご覧ください。"
  },
  "pokemon": {
    "q1": "これらのポケモンカードは本物ですか？",
    "a1": "すべての出品は認証済み英国出品者によるもので、鑑定カードには該当する場合PSA・BGS・CGCの証明書情報が記載されています。",
    "q2": "生カード（未鑑定）のポケモンカードも購入できますか？",
    "a2": "はい。生カードと鑑定カードの両方が出品されており、鑑定会社やグレードで絞り込めます。",
    "q3": "支払い方法は？",
    "a3": "すべてのオークションは英ポンド建てで、Stripeによる安全な決済に対応。受け取り確認まで資金は保留されます。",
    "q4": "未開封のポケモン商品も扱っていますか？",
    "a4": "はい。未開封のブースターBOXやパック、缶がシングルカードと共に出品されています。閲覧ページの商品タイプで絞り込めます。"
  },
  "onePiece": {
    "q1": "ワンピースカードゲームとは何ですか？",
    "a1": "バンダイが手掛ける、漫画・アニメ「ワンピース」を題材にしたトレーディングカードゲームで、世界中のコレクターに人気です。",
    "q2": "英語版・日本語版どちらも購入できますか？",
    "a2": "はい。カード言語で絞り込むことで、英語版・日本語版どちらのワンピースカードも探せます。",
    "q3": "ルフィのカードだけを探せますか？",
    "a3": "はい。専用のルフィコレクションでキャラクター別の出品をご覧いただけます。",
    "q4": "鑑定済みのワンピースカードはありますか？",
    "a4": "はい。PSA・BGS・CGC鑑定のワンピースカードが生カードと共に出品されています。"
  },
  "yugioh": {
    "q1": "ビンテージの遊戯王カードはありますか？",
    "a1": "はい。1stエディションや限定版を含む、ビンテージ・現行の遊戯王シングルカードが出品されています。",
    "q2": "遊戯王カードは鑑定されていますか？",
    "a2": "多くの出品はPSA・BGS・CGCによる専門鑑定済みですが、生カードもございます。",
    "q3": "日本語版の遊戯王カードは購入できますか？",
    "a3": "はい。カード言語で絞り込むことで日本語版遊戯王カードを見つけられます。",
    "q4": "即決価格（Buy Now）はありますか？",
    "a4": "多くの出品者がライブ入札に加えて即決価格を設定しています。出品ページのBuy Nowバッジをご確認ください。"
  },
  "psa10": {
    "q1": "PSA 10とは何ですか？",
    "a1": "PSA 10（ジェムミント）はProfessional Sports Authenticatorが付与する最高グレードで、ほぼ完璧な状態を示します。",
    "q2": "PSAの証明書を確認できますか？",
    "a2": "はい。PSA鑑定の出品には証明書番号が記載されており、PSA公式サイトで独自に確認できます。",
    "q3": "PSA 10の出品はどのジャンルにありますか？",
    "a3": "ポケモン、ワンピース、遊戯王、スポーツカードなど多岐にわたります。閲覧ページのフィルターでジャンルを絞り込めます。",
    "q4": "PSA 10カードは高額になりますか？",
    "a4": "ジェムミント状態は希少性と見た目の美しさから、低いグレードに比べプレミアムが付く傾向があります。"
  },
  "bgsBlack": {
    "q1": "BGSブラックラベルとは何ですか？",
    "a1": "ブラックラベルはBeckett社が付与する最も希少な認定で、センタリング・角・エッジ・表面の4項目すべてが満点10です。",
    "q2": "ブラックラベルカードはどれほど希少ですか？",
    "a2": "非常に希少です。多くのセットで鑑定総数のうちブラックラベルはごく数枚しかありません。",
    "q3": "BGSの証明書を確認できますか？",
    "a3": "はい。BGS鑑定の出品には証明書番号が記載されており、Beckett公式サイトで各項目を確認できます。",
    "q4": "ブラックラベルカードにはプレミアムが付きますか？",
    "a4": "はい。希少性から、通常のBGS 10と比べて大幅なプレミアムが付く傾向があります。"
  },
  "manga": {
    "q1": "漫画カードとは何ですか？",
    "a1": "漫画カードは通常のイラストの代わりに白黒や漫画風のアートを使用したパラレル版で、ワンピースをはじめ他のTCGでも人気です。",
    "q2": "漫画絵柄のカードがあるゲームは？",
    "a2": "ワンピースカードゲームが漫画レアで最もよく知られていますが、他のゲームでも同様のパラレルが発売されることがあります。",
    "q3": "漫画カードは鑑定されていますか？",
    "a3": "はい。鑑定済み・生カードの両方が出品されています。鑑定会社で絞り込むことができます。",
    "q4": "漫画カードは通常版より希少ですか？",
    "a4": "漫画レアは一般的に封入率が低いパラレルであり、通常のレアリティより希少とされています。"
  },
  "japanese": {
    "q1": "なぜコレクターは日本語版を好むのですか？",
    "a1": "日本語版カードは上質な用紙が使われ、発売が早く、独自のイラストバリエーションがあることが多いためです。",
    "q2": "日本語版カードの鑑定方法は同じですか？",
    "a2": "はい。PSA・BGS・CGCはすべて英語版と同じ基準で日本語版カードを鑑定します。",
    "q3": "日本語版の出品があるゲームは？",
    "a3": "ポケモン、ワンピース、遊戯王すべてに日本語版の出品があります。ジャンルフィルターでご覧ください。",
    "q4": "日本語版は英語版より高いですか？",
    "a4": "価格は主にレアリティと状態によって決まり、言語だけではありませんが、一部の日本限定版はプレミアムが付くことがあります。"
  },
  "english": {
    "q1": "出品の多くは英語版ですか？",
    "a1": "ポケモン、ワンピース、遊戯王、スポーツカードにおいて、英語版カードが出品の大部分を占めます。",
    "q2": "英語版カードは鑑定されていますか？",
    "a2": "はい。PSA・BGS・CGCなど各鑑定会社のカードに加え、未鑑定の生カードもございます。",
    "q3": "セットやエディションで絞り込めますか？",
    "a3": "はい。閲覧ページでセット、エディション（1stエディション／通常版）、仕上げ（ホロ／リバースホロ）で絞り込めます。",
    "q4": "英語版の未開封商品はありますか？",
    "a4": "はい。英語版のブースターBOXやパックがシングルカードと共に出品されています。"
  }
}
